import { render, staticRenderFns } from "./monitorResources.vue?vue&type=template&id=47123e6a&scoped=true&"
import script from "./monitorResources.vue?vue&type=script&lang=js&"
export * from "./monitorResources.vue?vue&type=script&lang=js&"
import style0 from "./monitorResources.vue?vue&type=style&index=0&id=47123e6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47123e6a",
  null
  
)

export default component.exports